import { render, staticRenderFns } from "./registeredStaff.vue?vue&type=template&id=275f2d57&scoped=true&"
import script from "./registeredStaff.vue?vue&type=script&lang=js&"
export * from "./registeredStaff.vue?vue&type=script&lang=js&"
import style0 from "./registeredStaff.vue?vue&type=style&index=0&id=275f2d57&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275f2d57",
  null
  
)

export default component.exports